var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_921_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1094 12C14.1094 13.1649 13.1649 14.1094 12 14.1094C10.8351 14.1094 9.89062 13.1649 9.89062 12C9.89062 10.8351 10.8351 9.89062 12 9.89062C13.1649 9.89062 14.1094 10.8351 14.1094 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 5.625H8.4375C6.8866 5.625 5.625 6.8866 5.625 8.4375V15.5625C5.625 17.1134 6.8866 18.375 8.4375 18.375H15.5625C17.1134 18.375 18.375 17.1134 18.375 15.5625V8.4375C18.375 6.8866 17.1134 5.625 15.5625 5.625ZM12 15.5156C10.0615 15.5156 8.48438 13.9385 8.48438 12C8.48438 10.0615 10.0615 8.48438 12 8.48438C13.9385 8.48438 15.5156 10.0615 15.5156 12C15.5156 13.9385 13.9385 15.5156 12 15.5156ZM16.0312 8.67188C15.6429 8.67188 15.3281 8.35712 15.3281 7.96875C15.3281 7.58038 15.6429 7.26562 16.0312 7.26562C16.4196 7.26562 16.7344 7.58038 16.7344 7.96875C16.7344 8.35712 16.4196 8.67188 16.0312 8.67188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 0H6.32812C2.83887 0 0 2.83887 0 6.32812V17.6719C0 21.1611 2.83887 24 6.32812 24H17.6719C21.1611 24 24 21.1611 24 17.6719V6.32812C24 2.83887 21.1611 0 17.6719 0ZM19.7812 15.5625C19.7812 17.8887 17.8887 19.7812 15.5625 19.7812H8.4375C6.11133 19.7812 4.21875 17.8887 4.21875 15.5625V8.4375C4.21875 6.11133 6.11133 4.21875 8.4375 4.21875H15.5625C17.8887 4.21875 19.7812 6.11133 19.7812 8.4375V15.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_921_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.4666b8da25fad85bf42e86f7b728bda6.svg";
export { ForwardRef as ReactComponent };